// Country / US-state name tables and a small flag-emoji helper.
// These mappings are used to render names alongside codes returned by the
// backend. The backend is authoritative on which codes exist (it only
// returns codes that have users); the UI layer owns the display names.

export const COUNTRY_NAMES = {
  US: "United States",
  CA: "Canada",
  GB: "United Kingdom",
  AU: "Australia",
  DE: "Germany",
  FR: "France",
  BR: "Brazil",
  IN: "India",
  MX: "Mexico",
  NG: "Nigeria",
  ZA: "South Africa",
  NZ: "New Zealand",
  IE: "Ireland",
  PH: "Philippines",
  PK: "Pakistan",
  JP: "Japan",
  CN: "China",
  KR: "South Korea",
  IT: "Italy",
  ES: "Spain",
  NL: "Netherlands",
  SE: "Sweden",
  NO: "Norway",
  DK: "Denmark",
  FI: "Finland",
  PL: "Poland",
  RU: "Russia",
  TR: "Turkey",
  AR: "Argentina",
  CL: "Chile",
  CO: "Colombia",
  PE: "Peru",
  EG: "Egypt",
  KE: "Kenya",
  GH: "Ghana",
  MA: "Morocco",
  ID: "Indonesia",
  MY: "Malaysia",
  SG: "Singapore",
  TH: "Thailand",
  VN: "Vietnam",
  BD: "Bangladesh",
  AE: "United Arab Emirates",
  SA: "Saudi Arabia",
  IL: "Israel",
  PT: "Portugal",
  GR: "Greece",
  BE: "Belgium",
  CH: "Switzerland",
  AT: "Austria",
};

export const US_STATE_NAMES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
  CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa",
  KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
  MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
  MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
  NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
  OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
};

/**
 * Render a country flag using the flag-icons CSS library.
 * Works on all platforms including Windows (uses SVG background images,
 * not Unicode regional indicator emoji which Windows does not render).
 *
 * Usage: <FlagIcon code="US" />
 */
export const FlagIcon = ({ code, className = "" }) => {
  if (!code || code.length !== 2) return null;
  return (
    <span
      className={`fi fi-${code.toLowerCase()} ${className}`.trim()}
      aria-label={code}
    />
  );
};

export const countryName = (code) => COUNTRY_NAMES[code] || code;
export const stateName = (code) => US_STATE_NAMES[code] || code;
